import { render, staticRenderFns } from "./PublicationsGrid.vue?vue&type=template&id=e4d1ce4a&"
import script from "./PublicationsGrid.vue?vue&type=script&lang=js&"
export * from "./PublicationsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports